module.exports = __webpack_public_path__ + "static/media/Student handbook final.ec4de435.pdf";